<template>
  <div class="content billing_sec">
    <PulseLoader :loading="!loaded" :class="{ hide: loaded }"></PulseLoader>
    <div class="md-layout">
      <div class="md-layout-item md-size-100" v-if="!showTransaction">
        <table-card>
          <template slot="header">
            <div class="card-icon">
              <md-icon>shopping_cart</md-icon>
            </div>
            <h3 class="title title-color-white">Invoices</h3>
          </template>

          <template slot="content">
            <!-- <div>
              <pulse-loader :color="'blue'" :loading="!loaded"></pulse-loader>
            </div> -->
            <template v-if="loaded && invoices.length">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 p-0">
                  <md-table v-model="invoices" table-header-color="blue" class="billing-and-invoices-table">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <!-- <md-table-cell md-label="">
                        <md-checkbox v-model="item.selected"></md-checkbox>
                      </md-table-cell> -->

                      <md-table-cell md-label="Customer Name">{{
                          user.firstName + ' ' + user.lastName
                      }}</md-table-cell>
                      <md-table-cell md-label="Transaction Type">Credit Card -
                        {{ item.status.capitalize() }}</md-table-cell>
                      <md-table-cell md-label="Ordered">{{
                          item.created_at | moment('DD/MM/YYYY')
                      }}</md-table-cell>
                      <md-table-cell md-label="Total">${{ item.amount.toFixed(2) }}</md-table-cell>
                      <md-table-cell class="btn-table-cell" md-label="Actions">
                        <md-button v-if="item.pdf" :md-ripple="false"
                          class="btn-add-cart md-info md-block access-button bottom-check">
                          <a :href="item.pdf" target="_blank" class="href-white">
                            PDF</a>
                        </md-button>
                        <md-button v-else @click="setInvoiceId(item.id)" :md-ripple="false"
                          class="btn-add-cart md-info md-block access-button bottom-check">
                          Pay Now
                        </md-button>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </div>
              <!-- @TODO: disabling for now to enable single transaction downloads -->
              <!-- <div class="md-layout-item md-size-100 text-left">
                <md-button class="md-raised md-info mt-4"
                  ><md-icon>save_alt</md-icon>Download Invoice(s)</md-button
                >
              </div> -->
            </template>
            <template v-if="loaded && !invoices.length">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 no_data">
                  <p>There are no invoices for the current user.</p>
                </div>
              </div>
            </template>
          </template>
        </table-card>
      </div>
      <div class="md-layout-item" v-if="showTransaction && loaded">
        <div class="md-layout-item md-small-size-100 md-size-100 p-0 mb-4">
          <div class="section-title my-2">Transaction Details</div>
        </div>
        <div class="text-left">
          <md-button @click="goBack" class="md-primary md-dense">
            Back to List
          </md-button>
        </div>
        <div class="md-layout" v-if="loaded">
          <div class="md-layout-item md-size-100 p-0">
            <table-card>
              <template v-if="transaction">
                <template slot="header">
                  <div class="card-icon">
                    <md-icon>receipt_long</md-icon>
                  </div>
                  <h4 class="title">
                    Transaction No: #{{ transaction.trans_id }}
                  </h4>
                </template>

                <template slot="content">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-25">
                      <h4 class="card-title"><b>Order Placed</b></h4>
                      <p>
                        {{
                            transaction.insert_date
                            | moment('dddd Do MMMM YYYY h:mm A')
                        }}
                      </p>
                    </div>
                    <div class="md-layout-item md-size-25">
                      <h4 class="card-title"><b>Name</b></h4>
                      <p>
                        {{ user.firstName + ' ' + user.lastName }}
                      </p>
                    </div>
                    <div class="md-layout-item md-size-25">
                      <h4 class="card-title"><b>Email</b></h4>
                      <p>{{ user.email }}</p>
                    </div>
                    <div class="md-layout-item md-size-25">
                      <h4 class="card-title"><b>Phone</b></h4>
                      <p>
                        {{
                            user.phoneNumber && user.phoneNumber !== "''"
                              ? user.phoneNumber
                              : 'N/A'
                        }}
                      </p>
                    </div>
                    <div class="md-layout-item md-size-25">
                      <h4 class="card-title"><b>Billing Address</b></h4>
                      <p>
                        {{
                            (user.streetAddres && user.streetAddress !== "''"
                              ? user.streetAddress + ', '
                              : '') +
                            (user.city && user.city !== "''"
                              ? user.city + ', '
                              : '') +
                            (user.province && user.province !== "''"
                              ? user.province + ' '
                              : '') +
                            (user.postalCode && user.postalCode !== "''"
                              ? user.postalCode
                              : '')
                        }}
                        {{
                            user.streetAddress === "''" &&
                              user.city === "''" &&
                              user.province === "''" &&
                              user.postalCode === "''"
                              ? 'N/A'
                              : ''
                        }}
                      </p>
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="!transaction">
                <template slot="header">
                  <div class="card-icon">
                    <md-icon>receipt_long</md-icon>
                  </div>
                  <h4 class="title">Transaction not found for current user</h4>
                </template>
              </template>
            </table-card>
          </div>
        </div>

        <div class="md-layout" v-if="loaded && transaction">
          <div class="md-layout-item md-size-100 p-0">
            <table-card>
              <template slot="header">
                <div class="card-icon">
                  <md-icon>dynamic_feed</md-icon>
                </div>
                <h4 class="title">Product Details</h4>
              </template>

              <template slot="content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0">
                    <md-table v-model="tableData" table-header-color="blue" class="billing-and-invoices-table">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Product Type">{{
                            item.productType
                        }}</md-table-cell>
                        <md-table-cell md-label="Industry">{{
                            item.industry
                        }}</md-table-cell>
                        <md-table-cell md-label="Market Area">{{
                            item.marketArea
                        }}</md-table-cell>
                        <md-table-cell md-label="Price">{{
                            item.price
                        }}</md-table-cell>
                      </md-table-row>
                    </md-table>
                    <br />
                    <h4 class="title order-total text-right" v-if="tableData.length">
                      <b>Order Total: ${{ cartTotal }}</b>
                    </h4>
                    <div v-if="!tableData.length">
                      There are no cart item data for this transaction
                    </div>
                    <br />
                  </div>
                </div>
              </template>
            </table-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableCard, PulseLoader } from '@/components';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'billing-and-invoices',
  components: {
    TableCard,
    PulseLoader,
  },
  data() {
    return {
      boolean: false,
      invoices: [],
      user: null,
      searchResult: [],
      searchDateResult: [],
      clearSearchData: [],
      searchInput: '',
      loaded: false,
      showTransaction: false,
      tableData: [],
      transaction: null,
      cartTotal: 0,
      cart: null,
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      isTos: (state) => state?.invoicesModule?.tos,
    }),
  },
  methods: {
     addInvoiceToCart: async function (invoiceId) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/cart/add_invoice',
          {},
          {
            params: {
              session_id: currentSession,
              invoice_id: invoiceId,
            },
          },
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          if (res.data.success) {
            this.$router.push({
              name: 'Cart',
            });
          }
        });
    },
    setInvoiceId: async function (invoiceId) {
      if (this.isTos) {
        this.addInvoiceToCart(invoiceId);
      }else
      {
        this.$store.commit('SET_INVOICE_ID', invoiceId);
        this.$router.push({
          name: 'Terms',
        });
      }

    },
    getInvoices: async function () {
      this.invoices = [];
      this.user = null;
      this.loaded = false;
      const options = {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
      };
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/transactions',
          {},
          {
            params: {
              session_id: currentSession,
            },
          },
          options
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { invoices, user } = res.data;
          this.invoices = invoices;
          this.user = user;
          this.loaded = true;
        });
    },
    getTransaction: async function (id) {
      this.transaction = null;
      this.user = null;
      this.loaded = false;
      const options = {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
      };
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/transaction',
          {},
          {
            params: {
              session_id: currentSession,
              transaction_id: id,
            },
          },
          options
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/transaction" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { transaction, user } = res.data;
          this.transaction = transaction;
          this.user = user;
          this.parseCartData();
          this.loaded = true;
        });
    },
    getTransactionPDF: async function () {
      const options = {
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        },
      };
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/transaction/pdf',
          {},
          {
            params: {
              session_id: currentSession,
              transaction: this.$route.params.tid,
            },
          },
          options
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/transaction/pdf" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          let url = res.data.url;
          window.open(url, '_blank');
        });
    },
    parseCartData: async function () {
      let parsedData = [];
      this.cartTotal = 0;

      for (let item of this.transaction.cart.cart_items) {
        parsedData.push({
          productType: item.profile.title,
          industry: item.profile.industry,
          marketArea: item.profile.area,
          price: '$' + item.price,
        });

        this.cartTotal = this.cartTotal + item.price;
      }

      this.tableData = parsedData;
    },
    showTransactionDetails(id) {
      this.showTransaction = true;
      this.getTransaction(id);
    },
    goBack() {
      this.showTransaction = false;
    },
  },
  async created() {
    await this.getInvoices();
  },
};
</script>
<style lang="scss">
.billing_sec {
  .md-card-table {
    margin: 15px 0;

    .md-card-header {
      background: #133a65;
      color: #fff;
      padding: 16px 20px;
      border-radius: 0 !important;
      margin: 0;
      display: flex;
      flex-wrap: wrap;

      .datepicker-box {
        position: relative;

        input {
          min-width: 125px;
          height: 25px !important;
          padding: 0 15px !important;
          font-size: 12px;
          margin: 5px 3px;
        }

        &:after {
          position: absolute;
          right: 10px;
          top: 7px;
          font-family: 'Material Icons';
          content: 'calendar_month';
          color: #133a65;
          font-size: 20px;
        }
      }

      select {
        padding: 0 15px !important;
        height: 25px !important;
        width: auto !important;
        font-size: 12px;
        margin: 5px 3px;
      }

      h4 {
        font-weight: 500;
        font-size: 24px;
        color: #fff !important;
        margin: 5px 0 !important;
      }

      .card-icon {
        display: none;
      }

      .md-button {
        height: 34px;
        margin-left: auto;
        align-self: center;
        font-size: 14px;
        line-height: 20px;
        text-transform: capitalize;
        box-shadow: none;

        .md-ripple {
          padding: 7px 20px 7px 10px !important;

          .md-button-content {
            color: #133a65 !important;

            .md-icon {
              color: #3b7ef1 !important;
            }
          }
        }
      }
    }

    .md-card-content {
      padding: 0;

      .billing-and-invoices-table {
        table {
          border: 1px solid #d9d9d9;

          .md-table-head {
            border: 1px solid #d9d9d9;
            padding: 3px 20px;
            background: rgba(59, 126, 241, 0.15);

            .md-table-head-label {
              color: #133a65 !important;
              font-weight: bold;
              letter-spacing: 0.4px;
            }
          }

          .md-table-cell {
            border: 1px solid #d9d9d9;
            padding: 7px 20px;

            .md-table-cell-container {
              color: #666;
              font-weight: 400;
            }
          }
        }
      }

      .no_data {
        border: 1px solid #d9d9d9;

        p {
          font-size: 15px;
          line-height: 20px;
          font-weight: 500;
          color: #3c4858;
          text-align: center;
          margin: 30px 0;
        }
      }
    }
  }
}

.pulse_loader {
  background: white;
}

.link {
  color: #0b60f2 !important;
}

.btn-add-cart {
  width: 5px !important;
  height: 25px !important;
  min-width: 65px !important;
  padding: unset !important;
}

.btn-table-cell {
  text-align-last: center;
}
</style>
